import { useMemo } from 'react';
import { Text } from '~/components/ui/Text';
import { ReportMessageType } from '~/shared';
import { formatRelativeTime } from '~/utils/date';
import {
	StyledContainer,
	StyledImage,
	StyledInfoContainer,
	StyledNameContainer,
	StyledTextContainer,
	StyledTimeText,
} from './ReportChatMessage.styled';

interface IReportChatMessage {
	characterId: string;
	createdAt: number;
	text: string;
	online: boolean;
	playerName?: string;
	accountId?: string;
	isStaff?: boolean;
	isStaffMessage?: boolean;
	isContinuation?: boolean;
	isFirst?: boolean;
	showAdminButtons?: boolean;
	currentUserIsAdmin?: boolean;
}

const ReportChatMessage = ({
	characterId,
	createdAt,
	text,
	online,
	playerName,
	accountId,
	isStaff,
	isStaffMessage,
	isContinuation,
	isFirst,
}: IReportChatMessage) => {
	const messageType = useMemo(() => {
		return isStaff
			? isStaffMessage
				? ReportMessageType.OUTGOING
				: ReportMessageType.INCOMING
			: isStaffMessage
			? ReportMessageType.INCOMING
			: ReportMessageType.OUTGOING;
	}, [isStaff, isStaffMessage]);

	const formattedTime = useMemo(() => {
		return formatRelativeTime(createdAt);
	}, [createdAt]);

	const displaySubtext = useMemo(() => {
		if (isStaffMessage) {
			return undefined;
		}
		const parts = [];
		if (accountId) parts.push(`#${accountId}`);
		if (characterId) parts.push(`ID: ${characterId}`);
		return parts.length > 0 ? parts.join(' ') : undefined;
	}, [isStaffMessage, accountId, characterId]);

	return (
		<StyledContainer
			$type={messageType}
			$isFirst={isFirst}
			$isContinuation={isContinuation}
		>
			{!isContinuation && (
				<StyledInfoContainer $type={messageType}>
					<StyledImage $online={online} $isStaff={isStaffMessage} />
					<StyledNameContainer
						$type={messageType}
						$online={online}
						$isStaff={isStaffMessage}
					>
						<Text className={'name'}>
							{playerName}
							{displaySubtext && <> {displaySubtext}</>}
						</Text>
						<Text className={'status'}>
							{isStaffMessage
								? 'Администратор'
								: online
								? 'Онлайн'
								: 'Не в сети'}
						</Text>
					</StyledNameContainer>
					<StyledTimeText>{formattedTime}</StyledTimeText>
				</StyledInfoContainer>
			)}
			<StyledTextContainer>
				<Text>{text}</Text>
			</StyledTextContainer>
		</StyledContainer>
	);
};

export { ReportChatMessage };
